// import '@babel/polyfill'; // Deprecated - see https://www.npmjs.com/package/@babel/polyfill
import "core-js"; // Required if using 'useBuiltIns: "entry"' in babel.config.js. Previously using @babel/polyfill
import Vue from "vue";
import App from "@/App.vue";
import router from "@/router/router";
import store from "@/store";
import i18n from "@/i18n/i18n";
import BootstrapVue from "bootstrap-vue";
import VueCroppie from "vue-croppie";
import "@stripe/stripe-js"; // Note - this causes the Stripe script to be automatically loaded into the page.

import api from "@/api";

// Load TinyMCE library globally.
// It is used in enough places that it makes sense to do this on app start-up.
import "tinymce/tinymce";
import "tinymce/plugins/code";
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/plugins/paste";
import "tinymce/plugins/table";
import "tinymce/themes/silver/theme";
import "tinymce/icons/default";

// Set development flag in store
store.commit("setIsDevelopment", process.env.NODE_ENV === "development");

// Prevent production tip on startup.
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueCroppie); // It feels wrong to be loading this here - would be better at component level

// Load the icon definitions from icons.js
require("@/icons");

// Make base URL available everywhere
Vue.prototype.$baseUrl = process.env.BASE_URL;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

// Automatic user sign-out
setInterval(async () => {
  // Only run this check if we currently think that the user is logged in.
  if (!store.state.user.logged_in) {
    return;
  }

  // Get user logged-in status.
  const response = await api.keepAlive("/api/keepAlive");

  // If the user is not actually logged in, redirect to the login page
  if (!response.data.loggedin) {
    api.redirectToLogin();
  }
}, 60000); // 1 minute. Could consider reducing this further, although be mindful of load on server.
